import { PaymentMethodType } from 'Jsx/CheckoutV4/types';

export function getNextPaymentMethod(
  currentPaymentMethod: PaymentMethodType,
  paymentMethodsList: PaymentMethodType[],
): PaymentMethodType {
  if (paymentMethodsList.length === 0) return currentPaymentMethod;
  let nextPaymentMethodIndex = 0;

  const isInLastPosition = (index: number) =>
    paymentMethodsList.length - 1 === index;

  paymentMethodsList.forEach((paymentMethod, index) => {
    if (paymentMethod.title === currentPaymentMethod.title) {
      nextPaymentMethodIndex = isInLastPosition(index) ? 0 : index + 1;
    }
  });

  return paymentMethodsList[nextPaymentMethodIndex] || currentPaymentMethod;
}
